import React, { Component } from 'react';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';

class PhoneInputDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: props.value || '', // Initialize with the provided value
      validationPattern: '',
      valid: true
    };
    
  }
  

  handlePhoneChange = (phone, data, event, formattedValue) => {
    this.setState({ phone: formattedValue });

    // Pass the updated phone value to a callback function if needed
    if (this.props.onChange) {
      this.props.onChange(formattedValue);
    }
    
  }

  render() {
 
    return (
      <PhoneInput
        country={'us'}
        value={this.state.phone}
        inputStyle={{ height: '40px', width: '100%' }}
        enableSearch
        autoFormat
        onChange={this.handlePhoneChange}
        inputProps={{
          name: 'phone',
          required: true
        }}
      />
       
    );
    
  }
}

export default PhoneInputDropdown;